import IconButton from "@mui/material/IconButton";
import { theme as defaultTheme } from "@mindlercare/ui-web";
import { styled } from "styled-components";

export const Container = styled.div`
  position: relative;
`;

export const InnerContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const TitleContainer = styled.div`
  font-size: ${defaultTheme.FONT.SIZE.EXTRA_LARGE};
  font-weight: ${defaultTheme.FONT.WEIGHT.BOLD};
  cursor: pointer;
  @media (max-width: 759px) {
    padding-top: 2px;
    padding-bottom: 2px;
  }

  &::first-letter {
    text-transform: uppercase;
  }
`;

export const ArrowContainer = styled(IconButton)`
  height: 40px;
  width: 40px;
  display: flex;
  margin-left: 4px;
  justify-content: center;
  color: ${defaultTheme.COLORS.GRAY_BLACK};
  align-items: center;
  @media (max-width: 759px) {
    width: 20px;
    padding: 0;
    height: 20px;
  }
  &:hover {
    background-color: ${defaultTheme.COLORS.GRAY_X_LIGHT};
  }
`;
